__turbopack_context__.v({
  "className": "interfont_7d07ac4c-module__fY01aG__className",
  "variable": "interfont_7d07ac4c-module__fY01aG__variable",
});
